import { apiClient } from "../config/api.config";
import {
  ChangePasswordPayload,
  UpdateUserSettingsPayload,
} from "../types/settings.definition";

export interface UpdateProfileImageRequest {
  photoUrl: string;
}

/**
 * Update user settings
 * @param userId - User ID
 * @param data - Settings to update
 */
export function updateUserSettings(
  userId: string,
  data: UpdateUserSettingsPayload
) {
  return apiClient.request({
    method: "put",
    url: `/users/${userId}/settings`,
    data,
  });
}

/**
 * Change user password
 * @param data - Current and new password
 */
export function changePassword(data: ChangePasswordPayload) {
  return apiClient.request({
    method: "post",
    url: `/account/change-password`,
    data,
  });
}

/**
 * Update user profile image
 * @param userId - User ID
 * @param data - New photo URL
 */
export function requestUpdateProfileImage(
  userId: string | number,
  data: UpdateProfileImageRequest
) {
  return apiClient.request({
    method: "put",
    url: `/users/${userId}/profile-image`,
    data,
  });
}

/**
 * Persist the language chosen in the header switcher onto the user's settings.
 * Merges — it only touches app_language, leaving theme/timezone/notifications alone.
 */
export function updateAppLanguage(userId: string, lang: string) {
  return apiClient.request({
    method: "put",
    url: `/users/${userId}/settings/language`,
    params: { lang },
  });
}
